import { STATUS_TYPES, Story } from '@shared/api/types/story';

import desktopBannerSrc from '../assets/bithotel-story-banner-desktop.png';
import mobileBannerSrc from '../assets/bithotel-story-banner-mobile.png';
import step2 from '../assets/bithotel-story-step-2.png';
import step3 from '../assets/bithotel-story-step-3.png';
import step4 from '../assets/bithotel-story-step-4.png';
import step4s2 from '../assets/bithotel-story-step-4-2.png';
import step5 from '../assets/bithotel-story-step-5.png';
import step6 from '../assets/bithotel-story-step-6.png';

export const guideToBuyingWelcomePackageInBitHotelAndEarningRewards: Story = {
  id: 'guide-to-buying-welcome-package-in-bitHotel-and-earning-rewards',
  type: 'SOQUEST',
  status: STATUS_TYPES.ACTIVE,
  name: 'Guide To Buying Welcome Package In Bithotel And Earning Rewards',
  index: 0,
  content: {
    type: 'HTML',
    metadata: {
      title: 'Magic Store Campaign: Earn $4 for Buying a Welcome Package at Bit Hotel!',
      description:
        'Join the web3 world at Magic Store by Magic Square. Earn $4 for Buying a Welcome Package at Bit Hotel!',
      keywords:
        'Web3, Crypto, Hot Offer, Magic Store, Magic Square, Bit Hotel Campaign, USDT, Web3 App Store, Decentralized Apps, Crypto Rewards, Bit Hotel, DApps, Win Crypto, Digital Assets, Web3 Technology',
    },
    hardcodedHtml: /* html */ `
    <picture>
      <source media="(min-width:568px)" width="3484" height="592" srcset="${desktopBannerSrc.src}">
      <img src="${mobileBannerSrc.src}"  width="596" height="212" alt="Banner">
    </picture>

    <div class="html-layout-container">
      <h1 class="html-text-center">
        Step-by-step guide for buying a Welcome Package in BitHotel
      </h1>

      <p>
        Stepping into the vibrant world of pixel-art gaming has never been more rewarding! In line with our mission to bridge enthralling experiences and blockchain value, we are ecstatic to join forces with BitHotel, an innovative social-first pixel-art game. To guide our esteemed community through the process, we've crafted a detailed step-by-step tutorial on acquiring a Welcome package in the BitHotel game. And to sweeten the deal, participants will be credited with an additional $4 for their engagement.
      </p>

      <p class="html-text-center">
        <a href="/hot-offers/bit-hotel" class="html-button-primary">
          Get your Welcome Package Now!
        </a>
      </p>

      <section>
        <h2>
          1. Go to the BitHotel Hot Offer and click “Claim Offer”
        </h2>
        <p class="html-list-item">
          It will ask you to switch between the browser and App Store. Click allow and it will lead you to the BitHotel App.
        </p>
      </section>

      <section>
        <h2>
          2. Download the app by clicking on “Get”. Wait until it downloads and install.
        </h2>

        <img src="${step2.src}" alt="App store page with app"  width="2324" height="1308" />
      </section>

      <section>
        <h2>
          3. Make sure that you Allow Notifications and Tracking on your device, you will receive a pop-up when you enter the game for the first time and it will ask you to allow them. This is important for tracking!
        </h2>

        <img src="${step3.src}" alt="Allow notification process"  width="2324" height="1308" />
      </section>

      <section>
        <h2>
          4. Create your character and register
        </h2>

        <img src="${step4.src}" alt="Registration process"  width="2324" height="1308" />

        <p class="html-list-item">
          Create your character and choose your Username. After that you will get to the screen to enter your email address. Make sure to check both of the boxes. After that click on Send Code. You will receive an email with a code, enter the numbers. The next step will be to create your password. (Create a strong one!)
        </p>

        <img src="${step4s2.src}" alt="App's screen after registration"  width="2324" height="1308" />

        <p class="html-list-item">
          You will end up with this screen, just click play
        </p>
      </section>


      <section>
        <h2>
          5. Play a game for 3-4 minutes until you see a pop-up for a welcome package purchase
        </h2>

        <img src="${step5.src}" alt="App's sign up bonus popup" width="2324" height="1308" />
      </section>

      <section>
        <h2>
          6. Purchase a welcome package
        </h2>

        <img src="${step6.src}" alt="App's successful purchase popup" width="2324" height="1308" />

        <p class="html-list-item">
          Click Ok and you are all set. You will receive your reward via a Binance Gift Card. (It can take up to 72 hours to receive your reward)
        </p>
      </section>

      <p class="html-text-center">
       <a href="/hot-offers/bit-hotel" class="html-button-primary">
          Join the BitHotel Adventure!
        </a>
      </p>
    </div>
  `,
  },
};
